export default {
  0: [ //Composer
    "0.9",
    "0.9",
    "0.85",
    "0.8",
    "0.8",
    "0.6 L",
    "0.5",
    "0.4",
    "0.3",
    "0"
  ],
  1: [
      "0.65 LM",
      "n.c.",
      "n.c."
  ],
  2: {
    0: [
      "n.c.","n.c."
    ],
    1: [
      "0,55 LM","0,35 LM"
    ],
    2: [
      "n.c.","n.c."
    ]
  },
  3: [ // Rainurés
    "0.95",
    "0.75 L",
    "0.65 L"
  ],
  4: "0.95",
  5: {  //Ronds
    0: [
      "0,3 LM",  //    P3E16
      "n.c.",   //    P3E20
      "n.c."    //    P3E32
    ],
    1: [
      "n.c.",    //    P6E16
      "n.c.",   //    P6E20
      "n.c."    //    P6E32
    ],
    2: [
      "0,9",   //P8E16
      "0,55 LM",//P8E20
      "0,3 LM", //P8E32
    ],
    3: [
      "n.c.", //P10E20
      "n.c."  //P10E32
    ]
  },
  6: [
    "0.8",
    "n.c.",
    "n.c.",
    "n.c.",
    "n.c."
  ],
  7: [
    "0,35 LMM",
    "n.c.",
    "n.c.",
    "0,3 LM",
    "n.c."
  ],
  8: [
    "0.6",
    "0.6",
    "0.8",
    "0.8",
    "0.8",
    "0.8"
  ],
  9: [
    "n.c.",
    "0.5 LMM",
    "n.c.",
    "n.c.",
    "0.65 LM"
  ],
  10: [ // souffler
    "0.7",
    "0.7",
    "0.7",
    "0.7",
    "0.7",
    "0.7",
    "0.7",
    "0.7"
  ],
  11: "0.4 L", // prairie
  12: "0.4 L", // brindille
  13: "0.65 LMM", // taillis
  14: "0.45 L", //Ecorce",
  15: "0.25 L", //Liane",
  16: "0.35 LM", //Chair de poule",
  17: "0.25 L", //Grain de beauté",
  18: "0.5 LM", //Ecaille",
  19: "0.15 L", //Fourrure",
  20: "0.55 LM", //Ligne de vie",
  21: "0.2", //Canevas",
  22: "0.3 L", //Patchwork",
  23: "0.8", //Jersey",
  24: "0.1", //Capiton",
  25: "0.45 LMM", //Ecossais",
  26: "0.1 L", //Brume",
  27: "0.5 L", //Pluie",
  28: "0.25 L", //Soleil",
  29: "0.35 L", //Vent",
  30: "0.3 LM", //Neige",
  31: "0.5 LMM", //Amplitude",
  32: "0.8", //Onde",
  33: "0.8", //Crépitement",
  34: "0.4 L", //Cadence",
  35: "0.55 L" //Fréquence
}



// WEBPACK FOOTER //
// ./src/constants/patternAlphaSabineRatios.js